<script>
    export let src;
    let video; // bind:video
    let isIframe = false;
    let isYoutube = false;
    let isVimeo = false;
    export let onClose;

    $: if((/youtube/i).test(src)){
        isYoutube = true;
        isIframe = true;
    } else if((/vimeo/i).test(src)){
        isVimeo = true;
        isIframe = true;
    } else {
        isIframe = false;
    }

    import UA from 'ua-parser-js';
    const ua = new UA();
    let mobile = ua.getResult().device['type'] == 'mobile';

    function close(){
        src = false;
        if(onClose){ onClose(); }
    }

    function fullscreen(){
        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) { 
            video.msRequestFullscreen();
        }
    }

    $: if(src && isIframe === false){
        if(mobile){
            // waiting for element to exist
            setTimeout(fullscreen, 500);
        }
    }
</script>

<!-- /*____________ Markup ____________*/ -->
{#if src}
<div class="background" on:click={close}></div>
<div class="center">
<div class="container">
    <div class="keepratio">
        <div class="close" on:click={close}><img src="./images/close.png" alt="Close Video"/></div>
        {#if isIframe}
            <iframe id="video" title="Video" src={src} allowfullscreen allow="autoplay" frameborder="0" />
        {:else}
            <!-- svelte-ignore a11y-media-has-caption -->
            <video id="video" controls autoplay bind:this={video}>
                <source src="{src}" type="video/mp4">
            </video>
        {/if}
    </div>
</div>
</div>
{/if}

<!-- /*____________ CSS ____________*/ -->
<style>
.background {
    background: rgba(0,0,0,1);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99101;
}

.container {    
    top: 30px;
    width: 70%;
    height: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}

.keepratio {
    width: 100%;
    height: 0px;
    position: relative;
    z-index: 99102;
    padding-top: 56.25%;
}

.close {
    z-index: 99999;
    position: absolute;
    top: -17px;
    right: -17px;
    width: 40px;
    height: 40px;
    border: 3px  solid white;
    border-radius: 50%;
    cursor: pointer;
}

video, iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: none;
}

.center {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
</style>